import { render, staticRenderFns } from "./Olamide.vue?vue&type=template&id=3956ab4a&scoped=true&"
import script from "./Olamide.vue?vue&type=script&lang=js&"
export * from "./Olamide.vue?vue&type=script&lang=js&"
import style0 from "./Olamide.vue?vue&type=style&index=0&id=3956ab4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3956ab4a",
  null
  
)

export default component.exports